export default {
  pt: 'Português',
  en: 'Inglês',
  es: 'Espanhol',
}
